/**
 * Fonction permettant de mettre en évidence le terme de recherche
 * @param {string} title
 * @param {string} searchTerm
 *
 * @returns {string}
 */
export function highlightSearchTerm(title, searchTerm) {
  // Term vide, retourne le titre tel quel
  if (!searchTerm.trim()) {
    return title;
  }

  const normalizeText = (text) =>
    text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

  // Normalise le titre et le terme de recherche
  const normalizedTitle = normalizeText(title);
  const normalizedSearchTerm = normalizeText(searchTerm).replace(
    /[-[\]{}()*+?.,\\^$|#\s]/g,
    "\\$&",
  );
  const regex = new RegExp(normalizedSearchTerm, "gi");

  // Création d'un tableau pour stocker les positions des correspondances
  let matchPositions = [];
  let match;

  // Utilisation du titre normalisé pour obtenir les positions des correspondances
  while ((match = regex.exec(normalizedTitle)) !== null) {
    matchPositions.push({
      start: match.index,
      end: match.index + match[0].length,
    });
  }

  // Remplacement des correspondances par le terme de recherche mis en évidence
  let highlightedTitle = "";
  let currentIndex = 0;
  matchPositions.forEach(({ start, end }) => {
    highlightedTitle += `${title.slice(
      currentIndex,
      start,
    )}<strong>${title.slice(start, end)}</strong>`;
    currentIndex = end;
  });
  highlightedTitle += title.slice(currentIndex);

  return highlightedTitle;
}
